import React from 'react'
import { Input } from "../common/form";
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/thrash.svg";
import { REGEX_VALUES } from 'utils/regexValues';

export const CustomSalaryBreakDown = (props) => {
    const { form, setForm, handleUpdateSalaryBreakdown } = props;
    
    const handleDeleteCustomSalaryBreakDown = (id) => {
        setForm(prevState => {
            const newSalaryBreakdown = prevState.salary_breakdown.filter(salaryBreakdown => salaryBreakdown.id !== id);
            
            return {
                ...prevState,
                salary_breakdown: newSalaryBreakdown,
            }
        });
    }
    
    return (
        <div>
            <div>
                <h4 className='text-[#1A202C] font-bold text-[16px]'>Custom Breakdown</h4>
            </div>
            
            <div className='mt-2'>
                {
                    form.salary_breakdown.filter(({ is_default }) => !is_default).map(({ salary_component, percentage, is_default, id }) => {
                        
                        return (
                            <div key={id} className='w-full'>
                                <div className="w-full flex items-center relative" key={id}>
                                    <div style={{ width: "44.5%", marginRight: 16 }}>
                                        <Input
                                            type="text"
                                            label="Name"
                                            placeholder="Input Here"
                                            value={salary_component}
                                            required
                                            onChange={(evt) => {
                                                const { value } = evt.target;
                                                if (!REGEX_VALUES.LETTERS_WITH_NUMBERS_AND_HYPHEN_ONLY.test(value) || value.length > 50) {
                                                    return;
                                                }
                                                
                                                handleUpdateSalaryBreakdown(id, {
                                                    salary_component: value,
                                                    percentage,
                                                    is_default,
                                                    id,
                                                })
                                            }}
                                        />
                                    </div>
                                    <div style={{ width: "44.5%"}}>
                                        <Input
                                            type="number"
                                            label="Value (%)"
                                            placeholder="Input Here"
                                            value={percentage}
                                            className="input-number"
                                            required
                                            onChange={(evt) => {
                                                const { value } = evt.target;
                                                
                                                handleUpdateSalaryBreakdown(id, {
                                                    salary_component,
                                                    percentage: value,
                                                    is_default,
                                                    id,
                                                })
                                            }}
                                        />
                                    </div>
                                    <IconTrash 
                                        className='absolute right-0 top-6 cursor-pointer' 
                                        onClick={() => handleDeleteCustomSalaryBreakDown(id)} 
                                    />
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
